import { render, staticRenderFns } from "./NavigationSide.vue?vue&type=template&id=04875dc9&scoped=true&"
import script from "./NavigationSide.vue?vue&type=script&lang=ts&"
export * from "./NavigationSide.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationSide.vue?vue&type=style&index=0&id=04875dc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04875dc9",
  null
  
)

export default component.exports